import { type Loadable, selector, waitForAllSettled } from "recoil";
import { enterPresentationMode, exitPresentationMode, preview, unPreview } from "../lib/messageBus";
import { HostId, PreviewMode } from "./atoms";
import { ShowShare, ShowStacks } from "./stackAtoms";
import { InPresentationMode, Orientation, ShowFileUploader } from "./uiAtoms";

/**
 * All the recoil selectors used in the app.
 * @module selectors
 * @category State
 */
import { strings } from "@quickpoint.me/shared";
import { AllFiles } from "./files";
import { FilterNamesSelector } from "./filters";
import { PublishAtom } from "./publish";
import { ComposedStack, StackCfKeysSelector } from "./stackSelectors";

export const IsInPortrait = selector<boolean>({
  key: "IsInPortrait",
  get: ({ get }) => {
    const orientation = get(Orientation);
    return orientation === strings.ui.portrait;
  },
});

export const InPresentationModeSelector = selector<boolean>({
  key: "InPresentationModeSelector",
  get: ({ get }) => {
    return get(InPresentationMode)
  },
  set: ({ set, get }, val) => {
    set(InPresentationMode, val)
    set(PreviewMode, val)
    const hostId = get(HostId)
    if (val) {
      const stack = get(ComposedStack);
      preview(hostId);
      enterPresentationMode(hostId, stack)
    } else {
      unPreview(hostId);
      exitPresentationMode(hostId)

    }
  }
})

export const TogglePanelFor = selector<"files" | "stacks" | "share" | true>({
  key: "ToggleSidePanelFor",
  get: () => true,
  set: ({ set, get }, val) => {
    const showStacks = get(ShowStacks);
    const showFileUploader = get(ShowFileUploader);
    const showShare = get(ShowShare);
    if (val === "files") {
      set(ShowFileUploader, !showFileUploader);
      set(ShowStacks, false);
      set(ShowShare, false);
    }

    if (val === "stacks") {
      set(ShowStacks, !showStacks);
      set(ShowShare, false);
      set(ShowFileUploader, false);
    }

    if (val === "share") {
      set(ShowShare, !showShare);
      set(ShowStacks, false);
      set(ShowFileUploader, false);
    }

    return;
  },
});

// This waits for all the init a sync calls to finish before telling the viewers that the author is ready
export const WaitForInitialAsyncCalls = selector<Loadable<unknown>[]>({
  key: "WaitForInitialAsyncCalls",
  get: ({ get }) => {
    const res = get(
      waitForAllSettled([StackCfKeysSelector, PublishAtom, FilterNamesSelector, AllFiles]),
    );

    return res;
  },
});
